<script setup>
    import { onMounted, ref } from 'vue';
    import useEula from '@/composables/useEula';
    import useAnnouncement from '@/composables/useAnnouncement';

    const { loading: eulaLoading, read: eulaRead, showModal: eulaShowModal, eula, onDecline: eulaOnDecline, onAccept: eulaOnAccept } = useEula();
    const { loading: announcementLoading, read: announcementRead, showModal: announcementShowModal, announcement, onAccept: announcementOnAccept } = useAnnouncement();

 

    const isEulaRead = ref(false);
    const handleEulaAccept = async () => {
        await eulaOnAccept();
        await announcementRead(); 
    };

    onMounted(async () => {
        const hasEula = await eulaRead();

        if (!hasEula) {
            await announcementRead();
        }
    });

  
</script>

<template>
    <div>
        <n-modal v-model:show="eulaShowModal" :mask-closable="false" style="z-index: 100;">
            <n-card class="max-w-4xl"
                    :bordered="false"
                    role="dialog"
                    aria-modal="true">
                <h2 class="text-xl font-bold text-center my-2">End User License Agreement</h2>
                <n-scrollbar class="max-h-[600px] shadow-sm p-3 border ">
                    <p class="text-base mb-6" v-html="eula?.Content">

                    </p>
                </n-scrollbar>
                <template #footer>
                    <n-checkbox v-model:checked="isEulaRead" class="flex justify-center">
                        I have read and agree to the terms and conditions
                    </n-checkbox>
                    <div class="flex justify-center mt-4">
                        <n-button class="!w-[110px] mr-6" block strong @click="eulaOnDecline">Decline</n-button>
                        <n-button class="!w-[110px]" type="primary" block strong @click="handleEulaAccept" :disabled="!isEulaRead" :loading="eulaLoading">Accept</n-button>
                    </div>
                </template>
            </n-card>
        </n-modal>

        <n-modal v-model:show="announcementShowModal" :mask-closable="false" style="z-index: 99;">
            <n-card class="max-w-4xl"
                    :bordered="false"
                    role="dialog"
                    aria-modal="true">
                <h2 class="text-xl font-bold text-center my-2">Announcement</h2>
                <n-scrollbar class="max-h-[600px] shadow-sm p-3 border ">
                    <p class="text-base mb-6" v-html="announcement?.Content">

                    </p>
                </n-scrollbar>
                <template #footer>
                    <div class="flex justify-center">
                        <n-button class="!w-[110px]" type="primary" block strong @click="announcementOnAccept" :loading="announcementLoading">Okay</n-button>
                    </div>
                </template>
            </n-card>
        </n-modal>
    </div>
  

</template>
